// extracted by mini-css-extract-plugin
export default {"wrapper":"Facet_wrapper__ILRN2","active":"Facet_active__islL7"};